import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line', image: 'https://readdy.ai/api/search-image?query=A%20pair%20of%20modern%20stylish%20sneakers%20placed%20elegantly%20on%20a%20clean%20white%20surface%20with%20soft%20natural%20lighting%2C%20minimalist%20product%20photography%20with%20cream%20background%2C%20subtle%20warm%20tones%2C%20high%20end%20fashion%20aesthetic%2C%20clean%20composition%20with%20soft%20shadows&width=200&height=150&seq=nav-cat-shoes-01&orientation=landscape' },
  { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line', image: 'https://readdy.ai/api/search-image?query=A%20cozy%20oversized%20cream%20colored%20hoodie%20neatly%20folded%20on%20a%20wooden%20surface%20with%20warm%20ambient%20lighting%2C%20minimalist%20fashion%20product%20photography%2C%20soft%20beige%20background%2C%20clean%20aesthetic%2C%20gentle%20shadows%2C%20casual%20luxury%20style&width=200&height=150&seq=nav-cat-hoodies-02&orientation=landscape' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-shirt-line', image: 'https://readdy.ai/api/search-image?query=A%20premium%20quality%20white%20cotton%20t-shirt%20laid%20flat%20on%20a%20light%20cream%20surface%2C%20minimalist%20clothing%20product%20photography%2C%20soft%20natural%20daylight%2C%20clean%20aesthetic%2C%20subtle%20wrinkles%20showing%20fabric%20texture%2C%20fashion%20editorial%20style&width=200&height=150&seq=nav-cat-tshirts-03&orientation=landscape' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-honour-line', image: 'https://readdy.ai/api/search-image?query=A%20stylish%20modern%20light%20beige%20jacket%20hanging%20on%20a%20minimalist%20wooden%20hanger%20against%20a%20clean%20cream%20wall%2C%20soft%20natural%20lighting%2C%20fashion%20product%20photography%2C%20elegant%20composition%2C%20warm%20neutral%20tones&width=200&height=150&seq=nav-cat-jackets-04&orientation=landscape' },
  { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-pantone-line', image: 'https://readdy.ai/api/search-image?query=A%20pair%20of%20well%20tailored%20casual%20beige%20trousers%20neatly%20folded%20on%20a%20light%20wood%20surface%20with%20natural%20morning%20light%2C%20minimalist%20fashion%20product%20photography%2C%20clean%20cream%20background%2C%20soft%20shadows%2C%20refined%20composition&width=200&height=150&seq=nav-cat-pants-05&orientation=landscape' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-user-3-line', image: 'https://readdy.ai/api/search-image?query=A%20stylish%20modern%20baseball%20cap%20in%20warm%20cream%20tone%20placed%20on%20a%20clean%20white%20surface%2C%20minimalist%20fashion%20accessory%20photography%2C%20soft%20natural%20lighting%2C%20clean%20aesthetic%2C%20gentle%20shadows%2C%20premium%20casual%20style&width=200&height=150&seq=nav-cat-headwear-06&orientation=landscape' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line', image: 'https://readdy.ai/api/search-image?query=A%20coordinated%20fashion%20clothing%20set%20including%20a%20neutral%20toned%20top%20and%20bottom%20arranged%20beautifully%20on%20a%20cream%20surface%2C%20minimalist%20product%20photography%2C%20soft%20ambient%20lighting%2C%20elegant%20composition%2C%20warm%20beige%20tones&width=200&height=150&seq=nav-cat-sets-07&orientation=landscape' },
  { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-box-3-line', image: 'https://readdy.ai/api/search-image?query=Soft%20premium%20cotton%20underwear%20neatly%20folded%20on%20a%20clean%20cream%20surface%20with%20gentle%20natural%20lighting%2C%20minimalist%20product%20photography%2C%20subtle%20warm%20tones%2C%20refined%20composition%20with%20soft%20shadows&width=200&height=150&seq=nav-cat-underwear-08&orientation=landscape' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-team-line', image: 'https://readdy.ai/api/search-image?query=A%20modern%20athletic%20sports%20jersey%20in%20neutral%20warm%20tones%20laid%20flat%20on%20a%20clean%20surface%2C%20minimalist%20sportswear%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20aesthetic%2C%20gentle%20shadows%2C%20premium%20athletic%20style&width=200&height=150&seq=nav-cat-jersey-09&orientation=landscape' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-glasses-line', image: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20stylish%20fashion%20accessories%20including%20a%20watch%20and%20bracelet%20arranged%20elegantly%20on%20a%20cream%20surface%2C%20minimalist%20product%20photography%2C%20soft%20warm%20lighting%2C%20refined%20clean%20composition%2C%20luxury%20detail&width=200&height=150&seq=nav-cat-accessories-10&orientation=landscape' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-handbag-line', image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20minimalist%20leather%20handbag%20in%20warm%20beige%20tone%20placed%20on%20a%20clean%20cream%20surface%2C%20soft%20natural%20lighting%2C%20fashion%20product%20photography%2C%20elegant%20composition%2C%20subtle%20shadows%2C%20premium%20quality&width=200&height=150&seq=nav-cat-bags-11&orientation=landscape' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-link', image: 'https://readdy.ai/api/search-image?query=A%20premium%20leather%20belt%20in%20warm%20brown%20tone%20elegantly%20coiled%20on%20a%20clean%20cream%20surface%2C%20minimalist%20fashion%20accessory%20photography%2C%20soft%20natural%20lighting%2C%20refined%20composition%2C%20subtle%20shadows&width=200&height=150&seq=nav-cat-belts-12&orientation=landscape' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-contrast-drop-line', image: 'https://readdy.ai/api/search-image?query=An%20elegant%20glass%20perfume%20bottle%20with%20warm%20amber%20liquid%20on%20a%20clean%20cream%20surface%2C%20minimalist%20luxury%20product%20photography%2C%20soft%20natural%20lighting%2C%20refined%20composition%2C%20subtle%20golden%20reflections%2C%20sophisticated%20aesthetic&width=200&height=150&seq=nav-cat-perfumes-13&orientation=landscape' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line', image: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20assorted%20lifestyle%20fashion%20items%20including%20sunglasses%20and%20a%20small%20accessory%20arranged%20on%20a%20cream%20surface%2C%20minimalist%20product%20photography%2C%20soft%20warm%20lighting%2C%20clean%20composition%2C%20gentle%20shadows&width=200&height=150&seq=nav-cat-other-14&orientation=landscape' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);
  const [mobileGuidesOpen, setMobileGuidesOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70 py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2 group"
        >
          <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-file-excel-2-line text-white text-lg"></i>
          </div>
          <span className="font-heading text-xl text-foreground-950 whitespace-nowrap">
            Vigorbuy Spreadsheet
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          <Link
            to="/"
            className="px-4 py-2 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-4-line mr-1"></i>
            Home
          </Link>

          <div ref={dropdownRef} className="relative">
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-store-2-line text-base"></i>
              Shop Categories
              <i className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''}`}></i>
            </button>

            {dropdownOpen && (
              <div className="absolute top-full left-0 mt-2 w-72 bg-background-50 border border-background-200/80 rounded-xl overflow-hidden animate-[fadeIn_0.15s_ease-out]">
                <div className="max-h-80 overflow-y-auto py-2">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:text-foreground-950 hover:bg-primary-50 transition-colors cursor-pointer"
                      onClick={() => setDropdownOpen(false)}
                    >
                      <div className="w-10 h-8 rounded-md overflow-hidden flex-shrink-0 bg-background-100">
                        <img src={cat.image} alt={cat.name} className="w-full h-full object-cover" />
                      </div>
                      {cat.name}
                    </a>
                  ))}
                </div>
              </div>
            )}
          </div>

          <Link
            to="/vigorbuy-spreadsheet-guide"
            className="px-4 py-2 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            Shopping Guide
          </Link>

          <Link
            to="/vigorbuy-spreadsheet-templates"
            className="px-4 py-2 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            Templates
          </Link>

          <Link
            to="/vigorbuy-spreadsheet-comparisons"
            className="px-4 py-2 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            Comparisons
          </Link>

          <Link
            to="/vigorbuy-spreadsheet-security"
            className="px-4 py-2 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            Security
          </Link>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-5 py-2 rounded-lg text-sm font-semibold bg-primary-500 text-white hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap ml-2"
          >
            Buy It Now
          </a>
        </div>

        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
        >
          <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 animate-[fadeIn_0.2s_ease-out] max-h-[70vh] overflow-y-auto">
          <div className="px-4 py-3 space-y-1">
            <Link
              to="/"
              className="flex items-center gap-2 px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              <i className="ri-home-4-line"></i>
              Home
            </Link>

            <button
              onClick={() => setMobileCatOpen(!mobileCatOpen)}
              className="w-full flex items-center justify-between px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className="flex items-center gap-2">
                <i className="ri-store-2-line"></i>
                Shop Categories
              </span>
              <i className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${mobileCatOpen ? 'rotate-180' : ''}`}></i>
            </button>

            {mobileCatOpen && (
              <div className="pl-4 space-y-1 border-l-2 border-background-200/60 ml-3">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors cursor-pointer"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    <div className="w-9 h-7 rounded overflow-hidden flex-shrink-0 bg-background-100">
                      <img src={cat.image} alt={cat.name} className="w-full h-full object-cover" />
                    </div>
                    {cat.name}
                  </a>
                ))}
              </div>
            )}

            <button
              onClick={() => setMobileGuidesOpen(!mobileGuidesOpen)}
              className="w-full flex items-center justify-between px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className="flex items-center gap-2">
                <i className="ri-book-open-line"></i>
                SEO Guides
              </span>
              <i className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${mobileGuidesOpen ? 'rotate-180' : ''}`}></i>
            </button>

            {mobileGuidesOpen && (
              <div className="pl-4 space-y-1 border-l-2 border-background-200/60 ml-3">
                <Link to="/vigorbuy-spreadsheet-guide" className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors" onClick={() => setMobileMenuOpen(false)}>
                  <i className="ri-guide-line text-xs"></i>Shopping Guide
                </Link>
                <Link to="/vigorbuy-spreadsheet-templates" className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors" onClick={() => setMobileMenuOpen(false)}>
                  <i className="ri-file-text-line text-xs"></i>Templates
                </Link>
                <Link to="/vigorbuy-spreadsheet-comparisons" className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors" onClick={() => setMobileMenuOpen(false)}>
                  <i className="ri-scales-3-line text-xs"></i>Comparisons
                </Link>
                <Link to="/vigorbuy-spreadsheet-security" className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors" onClick={() => setMobileMenuOpen(false)}>
                  <i className="ri-shield-check-line text-xs"></i>Security
                </Link>
                <Link to="/#blog" className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors" onClick={() => setMobileMenuOpen(false)}>
                  <i className="ri-article-line text-xs"></i>Blog Articles
                </Link>
              </div>
            )}

            <div className="border-t border-background-200/70 my-2"></div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center justify-center gap-2 px-3 py-3 rounded-lg text-sm font-semibold text-white bg-primary-500 hover:bg-primary-600 transition-colors cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              <i className="ri-shopping-bag-3-line"></i>
              Buy It Now
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}